import { createSlice } from '@reduxjs/toolkit'
import moment from 'moment-jalaali'
import api from '../../api/index'
import { startLoading, stopLoading } from './loadingSlice'
import { failed, success } from './snackSlice'

export const examSlice = createSlice({
  name: 'event',
  initialState: {
    events: [],
    allEvents: [],
    event: [],
    singleEvent: {},
    eventUsers: [],
    eventStages: [],
    refereeEvents: [],
    refereeEvent: [],
    refereeEventUsers: [],
    eventFiles: [],
  },
  reducers: {
    eventsFetch: (state, { payload }) => {
      state.events = payload
      state.events = state.events.map((items) => {
        return { ...items, closingDate: moment(items?.closingDate).format('jYYYY/jMM/jDD') }
      })
    },
    allEventsFetch: (state, { payload }) => {
      state.allEvents = payload
    },
    eventFetch: (state, { payload }) => {
      state.event = payload
      state.event.closingDate = moment(state.event.closingDate).format('jYYYY/jMM/jDD')
      state.event.expierDate = moment(state.event.expierDate).format('jYYYY/jMM/jDD')
    },
    fetchFiles: (state) => {
      state.eventFiles = []
      state.event?.eventAttachmentInfos?.map((item) => {
        return state.eventFiles.push({ nameFile: item.mimeType, file: undefined })
      })
    },
    eventFile: (state, payload) => {
      console.log(state, 'payload', payload)
      // state.eventFiles.filter(O)
    },
    singleEventFetch: (state, { payload }) => {
      state.singleEvent = payload
    },
    eventUsersFetch: (state, { payload }) => {
      state.eventUsers = payload
    },
    eventStagesFetch: (state, { payload }) => {
      state.eventStages = payload
    },
    usersEventFetch: (state, { payload }) => {
      state.usersEvent = payload
    },
    refereeEventsFetch: (state, { payload }) => {
      state.refereeEvents = payload
    },
    refereeEventFetch: (state, { payload }) => {
      state.refereeEvent = payload
    },
    refereeEventUsersFetch: (state, { payload }) => {
      state.refereeEventUsers = payload
    },
  },
})

export default examSlice.reducer

export const {
  eventsFetch,
  allEventsFetch,
  eventFetch,
  singleEventFetch,
  eventUsersFetch,
  eventStagesFetch,
  usersEventFetch,
  refereeEventsFetch,
  refereeEventFetch,
  refereeEventUsersFetch,
  fetchFiles,
  eventFile,
} = examSlice.actions

export const getEvents = () => (dispatch) => {
  const url = '/Events?first=1000&after=0'
  dispatch(startLoading())
  api
    .get(url)
    .then((res) => {
      const events = res?.data?.data
      if (events?.length) {
        dispatch(eventsFetch(events))
        dispatch(allEventsFetch(events))
      }
      dispatch(stopLoading())
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message ?? ''))
      dispatch(stopLoading())
    })
}

export const getEventsId = (id) => (dispatch) => {
  const url = `/Events/${id}`
  dispatch(startLoading())
  api
    .get(url)
    .then((res) => {
      const pkg = res?.data?.data
      dispatch(eventFetch(pkg))
      dispatch(fetchFiles(pkg))
      dispatch(stopLoading())
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message ?? ''))
      dispatch(stopLoading())
    })
}

export const addEvent = (data) => (dispatch) => {
  const url = '/Events'
  dispatch(startLoading())
  api
    .post(url, data)
    .then(() => {
      dispatch(success('رویداد با موفقیت ثبت شد'))
      dispatch(stopLoading())
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message ?? ''))
      dispatch(stopLoading())
    })
}

export const postEvent = (data) => (dispatch) => {
  const url = '/UserEvent/Subscribe'
  dispatch(startLoading())
  api.post(url, data).then(() => {
    dispatch(stopLoading())
    dispatch(success('شرکت در رویداد با موفقیت انجام شد'))
  })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message ?? ''))
      dispatch(stopLoading())
    })
}

export const editEvent = (data) => (dispatch) => {
  const url = '/Events'
  dispatch(startLoading())
  api
    .put(url, data)
    .then(() => {
      dispatch(success('رویداد با موفقیت بروزرسانی شد'))
      dispatch(stopLoading())
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message ?? ''))
      dispatch(stopLoading())
    })
}

export const getEvent = (id) => (dispatch) => {
  const url = `/Events/${id}`
  dispatch(startLoading())
  api
    .get(url)
    .then((res) => {
      const event = res?.data?.data
      if (event) dispatch(eventFetch(event))
      dispatch(stopLoading())
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message ?? ''))
      dispatch(stopLoading())
    })
}

export const deleteEvent = (id) => (dispatch) => {
  const url = `/Events/${id}`
  dispatch(startLoading())
  api
    .delete(url)
    .then(() => {
      dispatch(success('رویداد با موفقیت حذف شد'))
      dispatch(stopLoading())
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message ?? ''))
      dispatch(stopLoading())
    })
}

export const eventUsers = (params) => (dispatch) => {
  const url = '/UserEvent/Search'
  dispatch(startLoading())
  api
    .post(url, params)
    .then((res) => {
      const users = res?.data?.data
      if (users?.length) dispatch(eventUsersFetch(users))
      dispatch(stopLoading())
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message ?? ''))
      dispatch(stopLoading())
    })
}

export const addUserStage = (RefereeGroupId, StageId) => (dispatch) => {
  const url = `/Events/RefereeGroup/${RefereeGroupId}/AddTo/${StageId}

  `
  dispatch(startLoading())
  api
    .post(url)
    .then(() => {
      dispatch(stopLoading())
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message ?? ''))
      dispatch(stopLoading())
    })
}

export const getEventStages = () => (dispatch) => {
  const url = '/Events/Stages'
  dispatch(startLoading())
  api
    .get(url)
    .then((res) => {
      const stages = res?.data?.data
      if (stages?.length) dispatch(eventStagesFetch(stages))
      dispatch(stopLoading())
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message ?? ''))
      dispatch(stopLoading())
    })
}

export const addEventStage = (data) => (dispatch) => {
  const url = '/Events/Stages'
  dispatch(startLoading())
  api
    .post(url, data)
    .then(() => {
      dispatch(success('مرحله رویداد با موفقیت ساخته شد'))
      dispatch(stopLoading())
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message ?? ''))
      dispatch(stopLoading())
    })
}

export const deleteEventStage = (id) => (dispatch) => {
  const url = `beta/Events/Stages/${id}`
  dispatch(startLoading())
  api
    .delete(url)
    .then(() => {
      dispatch(stopLoading())
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message ?? ''))
      dispatch(stopLoading())
    })
}

export const getUsersEvent = () => (dispatch) => {
  const url = '/UserEvent/Search'
  dispatch(startLoading())
  api
    .get(url)
    .then((res) => {
      const users = res?.data?.data
      if (users?.length) dispatch(usersEventFetch(users))
      dispatch(stopLoading())
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message ?? ''))
      dispatch(stopLoading())
    })
}

export const getRefereeEvents = () => (dispatch) => {
  const url = '/EventRefereeing'
  dispatch(startLoading())
  api
    .get(url)
    .then((res) => {
      const events = res?.data?.data
      if (events?.length) dispatch(refereeEventsFetch(events))
      dispatch(stopLoading())
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message ?? ''))
      dispatch(stopLoading())
    })
}

export const refereeEvent = (data) => (dispatch) => {
  const url = '/EventRefereeing/EventRefereeing'
  dispatch(startLoading())
  api
    .post(url, data)
    .then(() => {
      dispatch(success('رای شما با موفقیت ثبت شد'))
      dispatch(stopLoading())
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message ?? ''))
      dispatch(stopLoading())
    })
}

export const getRefereeEventUsers = (data) => (dispatch) => {
  const url = '/EventRefereeing/SearchUserEventHistories'
  dispatch(startLoading())
  api
    .post(url, data)
    .then((res) => {
      const events = res?.data?.data
      if (events) dispatch(refereeEventUsersFetch(events))
      dispatch(stopLoading())
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message ?? ''))
      dispatch(stopLoading())
    })
}

export const selectorEvents = (state) => state.event.events

export const selectorEvent = (state) => {
  const { event } = state.event

  const eventAttachmentInfos = []
  event?.eventAttachmentInfos?.map((item) => eventAttachmentInfos.push(item.mimeType))

  const acceptFileTitle = []
  event?.eventAttachmentInfos?.map((item) => acceptFileTitle.push(item.title))

  const acceptFile = []
  eventAttachmentInfos?.map((item) => acceptFile.push(item))
  const conditions = event?.conditions?.split('\n')
  const awards = event?.awards?.split('\n')
  const laws = event?.laws?.split('\n')?.map(((item, index) => {
    return { item, id: index }
  }))

  return {
    conditions, awards, laws, event, eventAttachmentInfos, acceptFileTitle, acceptFile,
  }
}
export const selectorAllEvents = (state) => state.event.allEvents
export const selectorSingleEvent = (state) => state.event.event
export const selectorEventUsers = (state) => state.event.eventUsers
export const selectorEventStages = (state) => state.event.eventStages
export const selectorUsersEvent = (state) => state.event.usersEvent
export const selectorRefereeEvents = (state) => state.event.refereeEvents
export const selectorRefereeEvent = (state) => state.event.refereeEvent
export const selectorRefereeEventUsers = (state) => state.event.refereeEventUsers
export const selectorEventFiles = (state) => state.event.eventFiles
